
export {KidsWhitelistItem as default};

/**
 * Kids WhiteList Item Params
 *
 * @author rsommerfeld <roni.s.sommerfeld@altice.pt>
 *
 * @since 7.0.0
 */
class KidsWhitelistItem {
  /**
   * Email value
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  email;
}